import React from "react";
import useMediaQuery from "../../utils/CustomHooks/useMediaQuery";

const Percent02 = ({ width, height, color }) => {
  const isMobile = useMediaQuery("(max-width: 767.99px)");
  return (
    <svg
      width={width || isMobile ? "20" : "24"}
      height={height || isMobile ? "20" : "24"}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.5 5L5.5 19M9.5 7C9.5 8.10457 8.60457 9 7.5 9C6.39543 9 5.5 8.10457 5.5 7C5.5 5.89543 6.39543 5 7.5 5C8.60457 5 9.5 5.89543 9.5 7ZM19.5 17C19.5 18.1046 18.6046 19 17.5 19C16.3954 19 15.5 18.1046 15.5 17C15.5 15.8954 16.3954 15 17.5 15C18.6046 15 19.5 15.8954 19.5 17Z"
        stroke={color || "#374040"}
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default Percent02;
